import { render } from "./ihreVorteile.vue?vue&type=template&id=6967edd7"
import script from "./ihreVorteile.vue?vue&type=script&lang=js"
export * from "./ihreVorteile.vue?vue&type=script&lang=js"

import "./ihreVorteile.vue?vue&type=style&index=0&id=6967edd7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__